import type { Nullable } from "../types";
import { guardNumber } from "./guard-number";

/**
 * This function is used to sum up the values of a given key in an array of objects.^
 * @param data
 * @param key
 * @returns
 */
export function sumUpByKey<T extends object, U extends keyof T>(data: T[], key: U) {
	return data.reduce((acc, item) => {
		const value = item[key];
		if (!Number.isNaN(value)) {
			return acc + guardNumber(value);
		}
		return acc;
	}, 0);
}

export function sumUp(data: Nullable<number>[] | undefined | null): number {
	if (!data) return 0;
	return data.reduce((acc, item) => {
		if (!item) return acc as number;
		if (typeof item === "number") return guardNumber(acc) + item;
		return acc;
	}, 0) as number;
}
